import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
  HttpEvent,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngxs/store';
import { catchError, Observable, throwError } from 'rxjs';

import { AuthClearAction } from '../../shared/action/auth.action';
import { GetCountriesAction } from '../../shared/action/country.action';
import { GetCurrenciesAction } from '../../shared/action/currency.action';
import { GetSettingOptionAction } from '../../shared/action/setting.action';
import { GetStatesAction } from '../../shared/action/state.action';
import { GetThemeOptionAction } from '../../shared/action/theme-option.action';
import { IValues } from '../../shared/interface/setting.interface';
import { NotificationService } from '../../shared/services/notification.service';
import { SettingState } from '../../shared/state/setting.state';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private store = inject(Store);
  private router = inject(Router);
  private notificationService = inject(NotificationService);

  setting$: Observable<IValues> = inject(Store).select(SettingState.setting) as Observable<IValues>;

  public isMaintenanceModeOn: boolean = false;

  constructor() {
    this.store.dispatch(new GetCountriesAction());
    this.store.dispatch(new GetStatesAction());
    this.store.dispatch(new GetSettingOptionAction());
    this.store.dispatch(new GetThemeOptionAction());
    this.store.dispatch(new GetCurrenciesAction({ status: 1 }));
    this.setting$.subscribe(setting => {
      this.isMaintenanceModeOn = setting?.maintenance?.maintenance_mode!;
    });
  }

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    // If Maintainance Mode On
    if (this.isMaintenanceModeOn) {
      void this.router.navigate(['/maintenance']);
    }

    const token = this.store.selectSnapshot(state => state.auth.access_token);
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.notificationService.notification = false;
          this.store.dispatch(new AuthClearAction());
        }
        return throwError(() => error);
      }),
    );
  }
}
